import { Controller } from "@hotwired/stimulus"
import fetch from "lib/fetch"
import initAudioPlayers from "lib/init_audio_players"

export default class extends Controller {
  static targets = ["list", "buttonContainer"]
  static values = {
    loadingLabel: String,
    errorMessage: String,
  }

  #loading = false

  async load(event) {
    event.preventDefault()

    if (this.#loading) return

    const button = event.currentTarget
    const url = event.params.url
    const originalLabel = button.innerHTML

    this.#setLoadingState(button)

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
      })

      if (!response.ok) throw new Error()

      const payload = await response.json()

      this.#loading = false
      this.listTarget.insertAdjacentHTML("beforeend", payload.items_html)
      this.buttonContainerTarget.outerHTML = payload.load_more_html || ""

      // After the button, so a failure setting up a player can't strand the
      // cursor on the old page and append the same items twice.
      initAudioPlayers(this.listTarget)

      if (payload.current_page_path) {
        history.replaceState({}, "", payload.current_page_path)
      }
    } catch {
      this.#resetButtonState(button, originalLabel)

      alert(this.errorMessageValue)
    }
  }

  #setLoadingState(button) {
    this.#loading = true
    button.innerHTML = this.loadingLabelValue
    button.classList.add("is-loading")
    button.setAttribute("aria-disabled", "true")
  }

  #resetButtonState(button, originalLabel) {
    this.#loading = false
    button.innerHTML = originalLabel
    button.classList.remove("is-loading")
    button.removeAttribute("aria-disabled")
  }
}
